import * as React from 'react';
export const IcVirtualcurrencyBeta = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#ic_virtualcurrency_beta_svg__clip0_28944_150118)'>
      <path
        d='M23.79 5.19l-3.93 2.265a4.51 4.51 0 00-3.33-3.315L18.81.21a6.874 6.874 0 014.98 4.98z'
        fill='#fff'
      />
      <path
        d='M23.79 5.19l-3.93 2.265a4.51 4.51 0 00-3.33-3.315L18.81.21a6.874 6.874 0 014.98 4.98z'
        fill='#fff'
      />
      <path
        d='M7.455 4.14a4.557 4.557 0 00-3.33 3.315L.21 5.19A6.874 6.874 0 015.19.21l2.265 3.93z'
        fill='#7F4B10'
      />
      <path
        d='M4.005 15.435c0 .375.045.75.135 1.095L.21 18.81A6.995 6.995 0 010 17.115V6.885C0 6.3.075 5.73.21 5.19l3.93 2.265c-.09.36-.135.72-.135 1.095v6.885z'
        fill='#AC660C'
      />
      <path
        d='M7.455 19.86L5.19 23.79a6.874 6.874 0 01-4.98-4.98l3.93-2.265a4.552 4.552 0 003.33 3.33l-.015-.015z'
        fill='#FFE3AE'
      />
      <path
        d='M18.81 23.79c-.54.135-1.11.21-1.695.21H6.885a6.995 6.995 0 01-1.695-.21l2.265-3.93c.36.09.72.135 1.095.135h6.885c.375 0 .75-.045 1.095-.135l2.265 3.93h.015z'
        fill='#FFD947'
      />
      <path
        d='M23.79 18.81a6.898 6.898 0 01-4.98 4.98l-2.265-3.93a4.576 4.576 0 003.33-3.33l3.93 2.265-.015.015z'
        fill='#7F4B10'
      />
      <path
        d='M18.81.21l-2.265 3.93a4.38 4.38 0 00-1.095-.135H8.565c-.375 0-.75.045-1.095.135L5.19.21C5.73.075 6.3 0 6.885 0h10.23c.585 0 1.155.075 1.68.21h.015z'
        fill='#FFD947'
      />
      <path
        d='M24 6.885v10.23c0 .585-.075 1.155-.21 1.695l-3.93-2.265c.09-.345.135-.72.135-1.095V8.565c0-.375-.045-.75-.135-1.095l3.93-2.265c.135.54.21 1.11.21 1.695v-.015z'
        fill='#AC660C'
      />
      <path
        d='M21 8.13v7.74c0 .42-.06.84-.15 1.23a5.131 5.131 0 01-3.735 3.735 4.8 4.8 0 01-1.245.15H8.13A5.108 5.108 0 013.165 17.1c-.105-.39-.15-.81-.15-1.23V8.13c0-.42.06-.84.15-1.23A5.084 5.084 0 016.9 3.165c.39-.105.81-.15 1.23-.15h7.74c.435 0 .84.06 1.245.15A5.084 5.084 0 0120.85 6.9c.105.39.15.81.15 1.23z'
        fill='#F7AB20'
      />
      <path
        d='M16.995 9.72l-.135.75-.84 4.8a.3.3 0 01-.195.225c-1.215.33-2.505.495-3.825.495h-.405c-.69-.015-1.38-.09-2.04-.195-.315-.06-.645-.12-.945-.195-.135-.03-.285-.075-.42-.105a.274.274 0 01-.195-.225L7.02 9.72c-.045-.24.195-.42.39-.3l2.22 1.29c.12.075.285.03.36-.09l1.8-2.835a.266.266 0 01.45 0l.21.345 1.32 2.07.27.42c.075.12.24.165.36.09l.06-.03 2.16-1.26c.195-.12.435.06.39.3h-.015z'
        fill='#fff'
      />
      <path
        d='M16.995 9.72l-.135.75-.84 4.8a.3.3 0 01-.195.225c-1.215.33-2.505.495-3.825.495h-.405c-.69-.015-1.38-.09-2.04-.195-.315-.06-.645-.12-.945-.195-.135-.03-.285-.075-.42-.105a.274.274 0 01-.195-.225L7.02 9.72c-.045-.24.195-.42.39-.3l2.22 1.29c.12.075.285.03.36-.09l1.8-2.835a.266.266 0 01.45 0l.21.345 1.32 2.07.27.42c.075.12.24.165.36.09l.06-.03 2.16-1.26c.195-.12.435.06.39.3h-.015z'
        fill='#fff'
      />
    </g>
    <defs>
      <clipPath id='ic_virtualcurrency_beta_svg__clip0_28944_150118'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);
